<template>
  <div class="topbar-box">
    <div class="topbar">
      <span class="topbar-return">
        <a href="login.html">返回平台主页</a>
        <span>
          <select v-model="useUnion" @change="changeUnion($event)">
            <option v-for="(union,index) in unions" :key="index" :value="union.id">{{ union.name }}</option>
          </select>
        </span>
      </span>
      <span class="topbar-shopname">欢迎您！<span>{{ userInfo.shopName }}</span></span>
      <span class="topbar-nav">
        <span class="topbar-logout">
          <a href="login.html" @click="loginOut">安全退出</a>
        </span>|
        <a href="javascript:void(0)" class="topbar-cart" @click="goto('myCart')">购物车</a>|
        <a href="javascript:void(0)" class="topbar-order" @click="goto('orders')">我的订单</a>|
        <div class="dropdown">
          <a href="#" class="dropbtn" :class="{ background:isDropdown }" @click="dropdown">个人中心</a>
          <div v-if="isDropdown" class="dropdown-content">
            <a href="changePassword.html">修改密码</a>
          </div>
        </div>
      </span>
      <span class="topbar-phone">| 客服：020-87280493</span>
    </div>
  </div>
</template>
<script>
import { UserService } from '@/service/UserService'
export default {
  data () {
    return {
      useUnion: 1,
      user: {
        name: '广东星河药业有限公司'
      },
      isUnionChange: false,
      isDropdown: false
    }
  },
  computed: {
    userInfo: function () {
      return this.$store.getters.userInfo
    },
    unions: function () {
      return this.$store.getters.unions
    }
  },
  watch: {
    unions () {
      console.log('+++++++112131312', this.$store.getters.unions)
      console.log('+++++++112131312', this.$store.getters.unionId)
      this.useUnion = this.$store.getters.unionId
    },
    isUnionChange () {
      location.reload()
      return null
    }
  },
  mounted () {
    this.useUnion = this.$store.getters.unionId
    console.log(this.useUnion)
  },

  methods: {
    goto (url) {
      this.$router.push({ path: url })
    },
    changeUnion (event) {
      console.log(event.target.value, this.unions)
      var tmpUnionid = event.target.value
      var chooseUnions = this.unions.filter(union => union.id === tmpUnionid)
      var chooseUnion = chooseUnions[0]
      this.$store.commit('changeUnion', chooseUnion)
      // this.isUnionChange = !this.isUnionChange
    },
    // 使用页面
    dropdown (event) {
      event.preventDefault()
      const judgement = this.isDropdown
      this.isDropdown = !judgement
    },
    loginOut () {
      const user = new UserService(this.$axios)
      user.loginOut()
    }
  }
}
</script>
<style scoped>
  .topbar-box {
    width: 100%;
    background-color: #e3e4e5;
  }
  .topbar{
    font-size: 14px;
    line-height: 25px;
    min-width: 1200px;
    margin: 0 auto
  }
  .topbar-return {
    margin-right: 380px;
    color: #e54c51;
  }
  .topbar-return a{
    color: #e54c51;
    margin-right: 5px;
  }
  .topbar-shopname{
    position: relative;
    right: 300px;
  }
  .topbar-shopname span{
    color: #2ad53a;
  }
  .topbar-cart{
    margin-right: 10px;
    margin-left: 10px
  }
  .topbar-order,.topbar-user{
    margin-left: 10px;
    margin-right: 10px
  }
  .topbar-order:hover,.topbar-cart:hover,.dropbtn:hover
  ,.topbar-logout a:hover,.topbar-return a:hover{
    text-decoration: none;
  }
  .topbar-logout a{
    color: #ff0101;
    margin-right: 10px
  }
  .dropbtn {
    display: inline-block;
    padding: 0 10px;
    border: none;
    border: 1px solid #E3E4E5;
  }
  .background{
    color: #707070;
    background-color: #FEFEFE;
    border: 1px solid #808080;
    border-bottom: 1px solid #FEFEFE;
  }
  .dropdown {
    position: relative;
    display: inline-block;
    min-width: 76px;
  }
  .dropdown-content {
    margin-top: -1px;
    position: absolute;
    background-color: #f9f9f9;
    color: #909090;
    width: 78px;
    min-width: 78px;
    /* border: 1px solid #808080; */
    /* border-top: 1px solid #f9f9f9; */
    /* box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2); */
  }
  .dropdown-content a {
    color: #707070;
    text-decoration: none;
    display: block;
    border: 1px solid #808080;
    border-top: 1px solid #FEFEFE;
  }
  .dropdown-content a:hover {
    background-color: #f1f1f1;
    text-decoration: none;
  }
  .dropdown:hover .dropdown-content {
    display: block;
  }
</style>
